import { FlashListView } from './FlashList.view'

export const FlashList = () => {
  return <FlashListView />
}
